


























































































































import { defineComponent, ref, computed, watch } from '@nuxtjs/composition-api';
import { usePDPExtras, useTranslations } from '@vue-storefront/novulo';

export default defineComponent({
  name: 'BuySectionDeliveryModal',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      default: () => ({
        name: '',
        status: 'Op voorraad',
        manufacturers_suggested_retail_price: 0,
        first_price: 0,
        price: 0,
        price_after_cash_discount: 0,
        price_after_cashback_discount: 0,
        variations: [],
        spli_guid: '',
        spli_id: 0,
        sku: ''
      })
    }
  },
  setup(props) {
    const { getPDPStock } = usePDPExtras();
    const { translate } = useTranslations();

    const isLoading = ref(false);
    const error = ref(false);
    const availability = ref([]);

    const selectedOption = ref(null);

    const hasAlreadyLoadedStock = ref(false);

    const fetchStock = async () => {
      isLoading.value = true;
      try {
        const stock = await getPDPStock(props.product.product_id);
        availability.value = stock;
      } catch (e) {
        error.value = true;
      }
      isLoading.value = false;
    };

    watch(
      () => props.isVisible,
      async (newValue) => {
        if (newValue && !hasAlreadyLoadedStock.value) {
          await fetchStock();
          hasAlreadyLoadedStock.value = true;
        }
      }
    );

    const nonAvailablesOrdered = computed(() => {
      return (
        availability.value &&
        availability.value
          .filter((e) => !e.has_inventory)
          .sort((a, b) => {
            if (a.warehouse_name < b.warehouse_name) {
              return -1;
            }
          })
      );
    });

    const avaliablesOrdered = computed(() => {
      return (
        availability.value &&
        availability.value
          .filter((e) => e.has_inventory)
          .sort((a, b) => {
            if (a.warehouse_name < b.warehouse_name) {
              return -1;
            }
          })
      );
    });

    const update = (value: string) => {
      selectedOption.value = value;
    };

    return {
      nonAvailablesOrdered,
      avaliablesOrdered,
      selectedOption,
      isLoading,
      error,
      update,
      translate
    };
  }
});
